import { modals } from "@mantine/modals";
import DataTable from "../../../components/common/DataTable";
import { Button, Modal, NumberInput, Select } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import React from "react";
import { Link, useParams } from "react-router-dom";
import Head from "../../../components/common/Head";
import ContentModal from "../../../components/subcategories/ContentModal";
import SubModal from "../../../components/subcategories/SubModal";
import useValidate from "../../../hooks/useValidate";
import {
  addMovietoSubCategory,
  addSeriesToSubCategory,
  deleteSubCategory,
  getAllMovies,
  getAllSeries,
  getSubCategories,
} from "../../../utils/api";
import useStore from "../../../utils/store";

const SubCategories = () => {
  const user = useStore((state) => state.user);
  const { id, name } = useParams();
  
  const [buttonLoading, setButtonLoading] = React.useState(false);
  const [subCategories, setSubCategories] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [loading3, setLoading3] = React.useState(false);
  const [update, setUpdate] = React.useState(null);
  const [newSubCategory, setNewSubCategory] = React.useState({});
  const [modal, setModal] = React.useState(false);
  const [modal2, setModal2] = React.useState(false);
  const [content, setContent] = React.useState([]);
  const [contentid, setContentId] = React.useState(null);
  const [modal3, setModal3] = React.useState(false);
  const [movies, setMovies] = React.useState([]);
  const [series, setSeries] = React.useState([]);
  const params = useParams();
  const [add, setAdd] = React.useState({});

  const addDataToSubCategory = async () => {
    if (add.position === undefined) {
      notifications.show({ message: "Please enter position", color: "red" });
      return;
    }
    setButtonLoading(true);
    if (add.type === "movie") {
      const [success, response] = await addMovietoSubCategory({
        movieId: add.id,
        subcategoryId: add.sub,
        position: add.position,
      });

      if (success) {
        notifications.show({ message: "Movie added successfully", color: "green" });
        getSubCategoriesData();
      }
    } else {
      const [success, response] = await addSeriesToSubCategory({
        seriesId: add.id,
        subcategoryId: add.sub,
        position: add.position,
      });

      if (success) {
        notifications.show({ message: "Series added successfully", color: "green" });
        getSubCategoriesData();
      }
    }
    setAdd({});
    setModal3(false);
    setButtonLoading(false);
  };

  const getSubCategoriesData = async () => {
    setLoading(true);
    const [success, response] = await getSubCategories(id);
    if (success) setSubCategories(response);
    setLoading(false);
  };

  const getAllMoviesData = async () => {
    setLoading(true);
    const [success, response] = await getAllMovies();
    if (success) setMovies(response);
    setLoading(false);
  };

  const getAllSeriesData = async () => {
    setLoading(true);
    const [success, response] = await getAllSeries();
    if (success) setSeries(response);
    setLoading(false);
  };
  const delSubCategory = async (id) => {
    setLoading(true);
    const [success, response] = await deleteSubCategory(id);
    if (success) {
      notifications.show({ message: "Sub Category deleted successfully", color: "green" });
      getSubCategoriesData();
    }
    setLoading(false);
  };

  useValidate();
  React.useEffect(() => {
    getSubCategoriesData();
    getAllMoviesData();
    getAllSeriesData();
  }, []);
  return (
    <>
      
      <Head
        title={name}
        customButton={
          user?.addSubcategory ? (
            <Link to={`/sub/${params?.id}/add`}>
              <Button>Add</Button>
            </Link>
          ) : null
        }
      />
      {user?.getAllSubcategories && (
        <DataTable
          loading={loading}
          dataSource={subCategories}
          scroll={{ x: 1000 }}
          columns={[
            {
              title: "Name",
              dataIndex: "name",
              key: "name",
            },
            {
              title: "Position",
              dataIndex: "position",
              key: "position",
            },
            {
              title: "Image Type",
              dataIndex: "imageType",
              key: "imageType",
            },
            {
              title: "Content",
              dataIndex: "content",
              key: "content",
              render: (text, record) => (
                <Button
                  onClick={() => {
                    setContent(record.content);
                    setContentId(record._id);
                    setModal2(true);
                  }}
                >
                  View
                </Button>
              ),
            },
            {
              title: "Add Content",
              dataIndex: "addContent",
              key: "addContent",
              render: (text, record) => (
                <div className="col2">
                  {user?.addSeries && (
                    <Button
                      onClick={() => {
                        setAdd({
                          type: "series",
                          sub: record._id,
                          content: record.content,
                          position: record?.content?.length + 1,
                        });
                        setModal3(true);
                      }}
                    >
                      Add Series
                    </Button>
                  )}
                  {user?.addMovie && (
                    <Button
                      onClick={() => {
                        setAdd({
                          type: "movie",
                          sub: record._id,
                          content: record.content,
                          position: record?.content?.length + 1,
                        });
                        setModal3(true);
                      }}
                    >
                      Add Movie
                    </Button>
                  )}
                </div>
              ),
            },
            {
              title: "Action",
              dataIndex: "action",
              key: "action",
              render: (text, record) => (
                <div className="col2">
                  {user?.updateSubcategory && (
                    <Link to={`/sub/${params.id}/edit/${record?._id}`}>
                      <Button
                        style={{
                          width: "100%",
                        }}
                      >
                        Edit
                      </Button>
                    </Link>
                  )}
                  {user?.deleteSubcategory && (
                    <Button color="red"
                      variant="filled"
                      onClick={() => {
                        modals.openConfirmModal({
                          title: "Are you sure delete this SubCategories?",
                          labels: { confirm: "Yes", cancel: "No" },
                          confirmProps: { color: "red" },
                          onConfirm: () => delSubCategory(record._id),
                        });
                      }}
                    >
                      Delete
                    </Button>
                  )}
                </div>
              ),
            },
          ]}
        />
      )}

      <ContentModal
        modal2={modal2}
        setModal2={setModal2}
        content={content}
        id={contentid}
        reload={getSubCategoriesData}
      />
      <Modal
        title="ADD"
        opened={modal3}
        onClose={() => {
          setAdd({});
          setModal3(false);
        }}
      >
        <div className="flex flex-col gap-4">
          {add?.type === "series" ? (
            <Select
              placeholder="Select Series"
              value={add?.id}
              data={(series?.data || []).map((item) => ({
                label: item.name,
                value: item._id,
              }))}
              onChange={(value) => {
                setAdd({
                  ...add,
                  id: value,
                });
              }}
            />
          ) : (
            <Select
              placeholder="Select Movie"
              value={add?.id}
              data={(movies?.data || [])
                .filter(
                  (item) =>
                    add?.content?.find((i) => i?.item?._id === item?._id) ===
                    undefined
                )
                .map((item) => ({
                  label: item.name,
                  value: item._id,
                }))}
              onChange={(value) => {
                setAdd({
                  ...add,
                  id: value,
                });
              }}
            />
          )}

          <NumberInput
            placeholder="Position"
            value={add?.position}
            onChange={(value) => {
              setAdd({
                ...add,
                position: value,
              });
            }}
          />
          <Button onClick={addDataToSubCategory} loading={buttonLoading}>
            Add
          </Button>
        </div>
      </Modal>
      <SubModal
        modal={modal}
        setModal={setModal}
        getSubCategoriesData={getSubCategoriesData}
        update={update}
        newSubCategory={newSubCategory}
        setNewSubCategory={setNewSubCategory}
        setUpdate={setUpdate}
        id={id}
      />
    </>
  );
};

export default SubCategories;
